import { render, staticRenderFns } from "./PoStudyHistory.vue?vue&type=template&id=55b5cba9&scoped=true"
import script from "./PoStudyHistory.vue?vue&type=script&lang=js"
export * from "./PoStudyHistory.vue?vue&type=script&lang=js"
import style0 from "./PoStudyHistory.vue?vue&type=style&index=0&id=55b5cba9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b5cba9",
  null
  
)

export default component.exports